import _has from "./_has.js";
var toString = Object.prototype.toString;

var _isArguments =
/*#__PURE__*/
function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
}();

export default _isArguments;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isArguments.js
// module id = 891
// module chunks = 1